import { render } from "./FactoryDiagramView.vue?vue&type=template&id=5d921b38&scoped=true"
import script from "./FactoryDiagramView.vue?vue&type=script&lang=js"
export * from "./FactoryDiagramView.vue?vue&type=script&lang=js"

import "./FactoryDiagramView.vue?vue&type=style&index=0&id=5d921b38&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Anupashyam\\Downloads\\gitlabs - rel path oops\\virtuallab-oop\\exp-8\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d921b38"]])

export default __exports__